<div class="card-user cursor-pointer" [title]="user.name" [ngClass]="{'selecionado' : user.equipeId == userIdSelecionado}">
  <div class="row d-flex align-items-center position-relative">
    <div class="col-auto p-0">
      <img class="equipe-image" src="../../../../assets/img/chat/equipe_chat.svg" alt="User Image" />
    </div>

    <div class="col p-0 text-truncate">
      <div class="d-flex justify-content-between align-items-center">
        <span [ngClass]="temNotificacoes ? 'font-primary-gray-900' : 'font-primary-gray-500'"class="user-name text-truncate">{{ truncarNomeEquipe(user.name) }}</span>
        <span class="horario ml-1">{{ user.dataHora ? (user.dataHora | date: "HH:mm") : '' }}</span>
      </div>
      <div class="font-primary-gray-500 text-truncate">
        {{ user.clinica }}
        </div>
      <p *ngIf="user.ultimaMensagem" class="ultima-mensagem text-truncate">
        <img src="../../../../assets/img/chat/arrow.svg" alt="arrow">
        {{user.ultimaMensagem}}
      </p>
    </div>

    <div class="col-auto">
      <span *ngIf="temNotificacoes" class="notificacao-badge"></span>
    </div>
  </div>
</div>
